import { FeatureFlagGuard } from '@platform/client/feature-flags';
import type { FeatureConfig } from '@platform/client/features';

import { SubscriptionsGuard } from '@packages/components/subscriptions/subscriptions-guard/subscriptions-guard';
import { hasAnyRequiredProperty } from '@packages/utils/has-any-required-property';

import i18n from './locales/i18n';

const escalationsSubscriptions = {
  managedRisk: true,
  managedDetectionResponse: true,
};

export default {
  routes: [
    {
      path: 'account/escalations',
      element: <SubscriptionsGuard subscriptions={escalationsSubscriptions} />,
      children: [
        {
          index: true,
          lazy: () => import('./escalations/escalations.page'),
        },
        {
          path: ':escalationId',
          children: [
            {
              index: true,
              lazy: () => import('./escalation-detail/escalation-detail.page'),
            },
            {
              path: 'edit',
              element: (
                <FeatureFlagGuard featureFlag="SELF_SERVE_ESCALATIONS" />
              ),
              children: [
                {
                  index: true,
                  lazy: () =>
                    import('./escalation-detail/edit-escalation-detail.page'),
                },
              ],
            },
          ],
        },
        {
          path: 'new',
          element: <FeatureFlagGuard featureFlag="SELF_SERVE_ESCALATIONS" />,
          children: [
            {
              index: true,
              lazy: () =>
                import('./escalation-detail/add-escalation-detail.page'),
            },
          ],
        },
      ],
    },
  ],
  navigation: ({ subscriptions }) => {
    const canViewEscalations =
      subscriptions &&
      hasAnyRequiredProperty(escalationsSubscriptions, subscriptions);

    if (!canViewEscalations) return {};

    return {
      orgProfile: {
        escalations: {
          title: i18n.t('escalations:title'),
          segment: '/account/escalations',
        },
      },
    };
  },
} satisfies FeatureConfig;
